import { getField, updateField } from 'vuex-map-fields'

import Api from '../services/api'
import { Date } from 'sugar'
import LanguageService from '../services/language'
import ParamsService from '../services/params'
import Superstore from 'superstore'
import URL from 'url-parse'
import _ from 'lodash' /* webpackChunkName: "lodash" */

// import publicIp from 'public-ip'

const api = new Api()

const localStore = new Superstore('local', 'tn-inquiries-forms')

const state = {
  calLocale: 'en',
  isValid: false,
  staticParams: {},
  fields: {
    last_name: 'Name',
    first_name: 'Vorname',
    salutation_id: 'Anrede',
    country_id: 'Land',
    mail: 'E-Mail',
    arrival_at: 'Ankunft'
  },
  journeyIsValid: false,
  contactIsValid: false,
  accommondation: {},
  form: {},
  countries: {},
  salutations: {},
  lodgings: {},
  isLateExchange: false,
  languages: {},
  extras: [],
  types: [],
  offer: {},
  places: [],
  regions: [],
  locale: 'en',
  isLoading: false,
  isSaving: false,
  saveInBrowser: false,
  resetedInquiry: {},
  inquiry: {
    is_late_exchange: 0
  },
  pageIndex: 0,
  ipAddress: null,
  poolInfo: null,
  formInfo: null,
  isComplete: false,
  numberOfPages: 3,
  validationErrors: null,
  error: null,
  hasBrowserData: false
}

const mutations = {
  setLateExchange (state, value) {
    state.isLateExchange = value
    /*
    if (value === true) {
      state.pageIndex = state.numberOfPages - 1
    }
    */
  },
  setNumberOfPages (state, pages) {
    state.numberOfPages = pages - 1
  },
  setIpAddress (state, ipAddress) {
    state.ipAddress = ipAddress
  },
  setError (state, error) {
    state.error = error
  },
  setComplete (state, value = true) {
    state.isComplete = value
  },
  setHasBrowserData (state, value) {
    state.hasBrowserData = value
    if (value) {
      if (value.hasOwnProperty('arrival_at')) {
        const arrivalAt = Date.create(value.arrival_at)
        state.hasBrowserData.arrival_at = arrivalAt
      }
      if (value.hasOwnProperty('departure_at')) {
        const departureAt = Date.create(value.departure_at)
        state.hasBrowserData.departure_at = departureAt
      }
    }
  },
  setIsValid (state, value) {
    state.isValid = value
  },
  setJourneyIsValid (state, value) {
    state.journeyIsValid = value
  },
  setContactIsValid (state, value) {
    state.contactIsValid = value
  },
  updateField,
  resetForm (state) {
    state.inquiry = state.resetedInquiry
  },
  setValidationErrors (state, errors) {
  },
  setCountries (state, countries) {
    state.countries = countries
  },
  setLanguages (state, languages) {
    state.languages = languages
  },
  setSalutations (state, salutations) {
    state.salutations = salutations
  },
  setParams (state, data) {
    state.staticParams = data
    // state.countries = data.countries
    // state.salutations = data.salutations
    state.lodgings = data.lodgings
    // state.languages = data.languages
    state.extras = data.extras
    state.form = data.form
    state.types = data.types
    state.places = data.places
    state.regions = data.regions
    state.offer = data.offer
    state.resetedInquiry = data.inquiry
    state.resetedInquiry.GDPR = false
    state.poolInfo = data.poolInfo
    state.formInfo = data.formInfo
  },
  prevPage (state) {
    if (state.pageIndex > 0) {
      state.pageIndex--
    }
  },
  nextPage (state) {
    if (state.pageIndex < state.numberOfPages) {
      state.pageIndex++
    }
  },
  setPage (state, page) {
    state.pageIndex = page
  },
  setCalLocale (state, locale) {
    state.calendarLocale = locale
  },
  setSaveInBrowser (state, value) {
    state.saveInBrowser = value
  },
  setInquiry (state, inquiry) {
    state.inquiry = inquiry
  },
  fullInquiry (state, inquiry) {
    state.inquiry.id = inquiry.id
    state.inquiry.token = inquiry.token
    state.inquiry.type = inquiry.type
    state.inquiry.extras = inquiry.extras
    state.inquiry.lodgings = (typeof inquiry.lodgings === 'object') ? Object.values(inquiry.lodgings) : inquiry.lodgings
    state.inquiry.places = (typeof inquiry.places === 'object') ? Object.values(inquiry.places) : inquiry.places
    state.inquiry.types = (typeof inquiry.types === 'object') ? Object.values(inquiry.types) : inquiry.types
    state.inquiry.form = inquiry.form
    state.inquiry.pool_id = inquiry.pool_id
    state.inquiry.is_late_exchange = inquiry.is_late_exchange
    state.inquiry.unit_id = inquiry.unit_id || null
  },
  updateInquiry (state, payload) {
    state.inquiry[payload.name] = payload.value
  },
  updateInquiryExtra (state, payload) {
    if (payload.hasOwnProperty('adults')) {
      state.inquiry.extras['id-' + payload.id] = {
        value: payload.value,
        adults: payload.adults,
        childs: payload.childs
      }
    } else {
      state.inquiry.extras['id-' + payload.id] = payload.value
    }
  },
  setLocale (state, locale) {
    state.locale = locale
  },
  setIsLoading (state, loading) {
    state.isLoading = loading
  },
  setIsSaving (state, saving) {
    state.isSaving = saving
  }
}

const getters = {
  getField,
  offer: state => state.offer,
  getCountries: state => {
    if (!(state.countries instanceof Array)) return []
    const countries = []
    state.countries.forEach(country => {
      countries.push({
        id: country.id,
        name: (state.locale === 'de') ? country.name : country.name_en,
        pos: country.pos
      })
    })
    return _.sortBy(countries, ['pos', 'name'])
  }
}

const actions = {
  async setLocale ({ commit, dispatch, state }, locale) {
    const languageService = new LanguageService(null, state.languages)
    try {
      const payload = await languageService.setLocale(locale)
      commit('setLocale', payload.locale)
      commit('setCalLocale', payload.calLocale)
      return Promise.resolve(payload)
    } catch (error) {
      state.error = error
      return Promise.reject(error)
    }
  },
  async resetBrowser ({ commit, dispatch }, payload) {
    await localStore.clear()
    commit('setHasBrowserData', false)
  },
  async getInquiry ({ commit, dispatch }, payload) {
    const inquiry = await api.get('inquiries/data')
    dispatch('setInquiry', {
      useCache: (!payload.inquiryToken),
      inquiry: inquiry,
      payload: {
        arrival: payload.arrival,
        departure: payload.departure
      }
    })
  },
  async getIpAddress ({ commit, dispatch }, payload) {
    try {
      const ipAddress = await ParamsService.getIpAddress()
      commit('setIpAddress', ipAddress)
    } catch (error) {
      console.log(error)
    }
  },
  async getParams ({ commit, dispatch, state }, payload) {
    try {
      const params = await ParamsService.loadParams(payload, {
        xid: state.ipAddress
      })
      commit('setParams', params)

      let length = 0
      if (params.hasOwnProperty('extras')) {
        length = params.extras.length
      }

      if (params.inquiry.type === 3) {
        commit('setNumberOfPages', (length > 0) ? 4 : 3)
      } else {
        commit('setNumberOfPages', 3)
      }

      if (payload.inquiryToken) {
        dispatch('setInquiry', {
          useCache: (!payload.inquiryToken),
          inquiry: params.inquiry,
          payload: {
            arrival: payload.arrival,
            departure: payload.departure
          }
        })
      } else {
        commit('fullInquiry', params.inquiry)
      }

      return Promise.resolve(params)
    } catch (error) {
      state.error = error
      return Promise.reject(error)
    }
  },
  async saveInquiry ({ commit, dispatch, state }, release = false) {
    commit('setIsSaving', true)
    let inquiry = Object.assign({}, state.inquiry)
    const url = (release) ? '/inquiries/save-ext/release' : '/inquiries/save-ext'
    if (release) {
      inquiry.status = 1 // (inquiry.is_late_exchange) ? 2 : 1
    }
    inquiry.lang_iso_code = state.locale
    try {
      await api.post(url, inquiry)
      commit('setIsSaving', false)
      if (state.saveInBrowser) {
        let inquiry = Object.assign({}, state.inquiry)
        inquiry = _.omit(inquiry, [
          'id', 'token', 'created_at', 'type', 'parent_id', 'status', 'updated_at',
          'pool_id', 'requested_on', 'fullname', 'source', 'org_created_at', 'browser', 'lang_iso_code',
        ])
        await localStore.set('savedData', inquiry)
      }
      return Promise.resolve()
    } catch (error) {
      commit('setIsSaving', false)
      state.error = error
      return Promise.reject(error)
    }
  },
  async getFromLocalStore ({ commit, dispatch }) {
    const savedData = await localStore.get('savedData')
    return savedData
  },
  async setInquiry ({ commit, dispatch, state }, payload) {
    let useCache = false
    let inquiry = Object.assign({}, payload.inquiry)

    if (inquiry.id) {
      if (payload.inquiry.arrival_at) {
        inquiry.arrival_at = Date.create(payload.inquiry.arrival_at)
      }
      if (payload.inquiry.departure_at) {
        inquiry.departure_at = Date.create(payload.inquiry.departure_at)
      }
    }

    const url = new URL(document.referrer || window.location.hostname)
    commit('setComplete', false)
    inquiry.source = url.hostname.replace('www.', '')
    inquiry.is_exchange = 0
    if (payload.useCache) {
      const savedData = await dispatch('getFromLocalStore')
      commit('setHasBrowserData', (savedData))
      if (inquiry.is_late_exchange !== 1 && localStore) {
        inquiry = Object.assign(inquiry, savedData)
        useCache = 1
      }
    }

    /*
    if (state.isLateExchange === true) {
      commit('setPage', 3)
    }
    */

    if (inquiry.status < 1) {
      inquiry.status = 0
    }

    if (payload.payload.arrival) {
      const arrivalAt = Date.create(payload.payload.arrival, 'de')
      inquiry.arrival_at = arrivalAt
    }

    if (payload.payload.departure) {
      const departureAt = Date.create(payload.payload.departure, 'de')
      inquiry.departure_at = departureAt
    }

    inquiry.GDPR = false
    inquiry.unit_id = null

    commit('setSaveInBrowser', useCache)
    commit('setInquiry', inquiry)
    return Promise.resolve()
  }
}

export default {
  state, mutations, actions, getters
}
